import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from "@angular/common/http";
import { Observable, Subscriber } from 'rxjs';

@Injectable()
export class SettingsService extends BaseService{

  apiUrl = "Settings.php?";

  hidePurchasedItems: boolean;
  hidePurchasedItemsValueFetched: boolean;

  constructor(protected http: HttpClient) {
    super(http);
  }

  setWebSettings(sendMailForWishlistDrops: boolean, dealFlags: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "setWebSettings"),
      new UrlParam("emailWishlist", sendMailForWishlistDrops ? "1" : "0"),
      new UrlParam("dealFlags", dealFlags),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  getSettings(sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl +
    this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "getSettings"),
      new UrlParam("sessionToken", sessionToken),
    );
    return this.get(url);
  }

  getHidePurchasedItems(sessionToken: string, country: string, force?: boolean): Observable<boolean> {
    return Observable.create((observer: Subscriber<boolean>) => {
      if (!force && this.hidePurchasedItemsValueFetched) {
        observer.next(this.hidePurchasedItems);
        observer.complete();
      }
      else {
        this.getSettings(sessionToken, country).subscribe(res => {
          if (res) {
            if (res["userSettings"]) {
              this.hidePurchasedItems = res["userSettings"].hidePurchasedItems;
              this.hidePurchasedItemsValueFetched = true;
              observer.next(this.hidePurchasedItems);
              observer.complete();
            }
            else if (res["message"]) {
              observer.error(res["message"]);
            }
            else {
              observer.error();
            }
          }
          else {
            observer.error();
          }
        }, err => {
          observer.error();
        });
      }
    });
  }

  updateActiveCountry(country: string, newActiveCountry: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "updateActiveCountry"),
      new UrlParam("newActiveCountry", newActiveCountry),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  private _setHidePurchasedItems(country: string, sessionToken: string, value: boolean) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "setHidePurchasedItems"),
      new UrlParam("value", value ? "1" : "0"),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  setHidePurchasedItems(country: string, sessionToken: string, value: boolean) {
    return Observable.create((observer: Subscriber<boolean>) => {
      this._setHidePurchasedItems(country, sessionToken, value).subscribe(res => {
        if (res) {
          if (res["status"] === "success") {
            this.hidePurchasedItems = value;
            observer.next();
            observer.complete();
          }
          else {
            observer.error(res["message"]);
          }
        }
        else {
          observer.error();
        }
      }, err => {
        observer.error();
      });
    });
  }

}
